import registerFile from '../../../common/files/index';

import presentationalComponent from './File';
import containerComponent from './FileContainer';
import modalComponent from './modal/FileModal';

import { isIconViewMode } from '../../../common/elements/utils/elementDisplayUtils';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';

export default () =>
    registerFile({
        containerComponent,
        presentationalComponent,
        modalComponent,
        tools: [
            TOOLS.RICH_TEXT,
            TOOLS.COLOR,
            TOOLS.DISPLAY_MODE,
            TOOLS.MEDIA_LOOP,
            TOOLS.MEDIA_AUTOPLAY,
            {
                ...TOOLS.CAPTION,
                name: 'Description',
                predicate: (element) => !isIconViewMode(element),
            },
            { ...TOOLS.REACTION, predicate: (element) => !isIconViewMode(element) },
        ],
    });
